export function formatMoney(value) {
  const n = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
  return typeof n === "number" && Number.isFinite(n) ? `$${n.toFixed(2)}` : "—";
}


export function formatUsPhone(value) {
  const raw = String(value || "").trim();
  const d = raw.replace(/\D/g, "");
  const local = d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
  if (local.length === 10) return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  return raw;
}

export function displayWebsite(url) {
  return String(url || "").replace(/^https?:\/\//i, "").replace(/\/+$/, "");
}